require('./brokerHirePensionPlanError.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const { EmptyState } = require('commonsComponents/emptyState');
const BrokerFormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
// @ constants
const {
    BROKER_HIRE_PENSION_PLAN_IS_IN_WALLET,
    BROKER_HIRE_PENSION_PLAN_ERROR_SECONDARY,
    BROKER_PG_URL,
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL,
    BROKER_HIRE_PENSION_PLAN_ERROR_TO_PERIODIC_CONTRIB,
    BROKER_HIRE_PENSION_PLAN_ERROR_TO_EXTRAORDINARY_CONTRIB
} = require('constants/index');

class BrokerHirePensionPlanError extends React.Component {

    buildWalletReturnButton() {
        const { errType } = this.props;
        const url = BROKER_PG_URL;
        const inverseColor = !(errType == BROKER_HIRE_PENSION_PLAN_IS_IN_WALLET);

        return (
            <OKButton
                inverse={inverseColor}
                modifier="ghost"
                to={url}
            >
                <FormattedText value="broker-backToMyWallet" />
            </OKButton>
        );
    }

    buildPlanPeriodicalContributionManagementButton() {
        const { errType } = this.props;
        const url = MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL

        if(errType == BROKER_HIRE_PENSION_PLAN_IS_IN_WALLET) {
            return null;
        }

        return (
            <OKButton
                modifier={BROKER_HIRE_PENSION_PLAN_ERROR_SECONDARY} //'secondary'
                to={url} >
                <FormattedText value="broker-goToContributionsManagement" />
            </OKButton>
        );
    }


    buildButtonBlock() {
        return (
            <div className="hire-plans-error__button-block">
                <hr/>
                {this.buildWalletReturnButton()}
                {this.buildPlanPeriodicalContributionManagementButton()}
            </div>
        );
    }

    buildLinkBlock() {
        const { planId } = this.props;
        const extraordinaryContribLinkURL = `${BROKER_HIRE_PENSION_PLAN_ERROR_TO_EXTRAORDINARY_CONTRIB}${planId}`;
        const extraordinaryContribLinkText = formatText("brokerHirePlans-extraordinaryContrib");
        const periodicContribLinkURL = `${BROKER_HIRE_PENSION_PLAN_ERROR_TO_PERIODIC_CONTRIB}${planId}`;
        const periodicContribLinkText = formatText("brokerHirePlans-periodicContrib");

        const extraordinaryContribLink = (
            <OKLink
                modifier="emphasize"
                to={extraordinaryContribLinkURL}>
                {extraordinaryContribLinkText}
            </OKLink>
        )
        const periodicContribLink = (
            <OKLink
                modifier="emphasize"
                to={periodicContribLinkURL}>
                {periodicContribLinkText}
            </OKLink>
        )

        return [extraordinaryContribLink, periodicContribLink]
    }

    buildParagraphs() {
        const { errType } = this.props;
        const line1 = "brokerHirePlans-errorLine1";
        const line2 = errType == BROKER_HIRE_PENSION_PLAN_IS_IN_WALLET ?
            "brokerHirePlans-errorLine2A" : "brokerHirePlans-errorLine2BLink"


        return (
            <div>
                <FormattedText value={line1} />
                <br/>
                <BrokerFormattedTextWithComponents
                    value={line2}
                    injectedComponents={this.buildLinkBlock()}/>
            </div>
        );
    }

    render() {
        return (
            <ContentBox customClassName="hire-plans-error">
                <EmptyState
                    secondaryText={this.buildParagraphs()}
                    button={this.buildButtonBlock()}
                    iconType="noitems-wealth" />
            </ContentBox>
        )
    }
}

BrokerHirePensionPlanError.propTypes = {
    errType: PropTypes.number.isRequired,
    planId: PropTypes.string.isRequired
}

module.exports = BrokerHirePensionPlanError;
